export default __webpack_public_path__ + "static/media/agriculture.f3eb7e6a.png";